import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreFacilities$1 from './StoreFacilities.js';

const StoreFacilitiesContainer = (_param)=>{
    var { facilities  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "facilities"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.facilities.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreFacilities$1, swcHelpers.extends({
        labels: labels,
        facilities: facilities
    }, rest));
};
var StoreFacilities = StoreFacilitiesContainer;

export { StoreFacilities as default };
//# sourceMappingURL=StoreFacilitiesContainer.js.map
